import React from "react";
import styles from "./styles.module.scss";
import InstallDescription from "../InstallDescription";
import InstallNote from "../InstallNote";

const TroubleshootingDesktopBody = ({
  instructions,
  sensorType,
  helpChoice,
}) => {
  return (
    <div className={styles.desktop_instructions}>
      <ol className={styles.instructions_steps}>
        {instructions.map((item, index) => {
          if (item?.text) {
            if (helpChoice === "None of the other steps worked") {
              if (
                (sensorType === "Smart plug" && index !== 0) ||
                (sensorType !== "Smart plug" && index !== 1)
              ) {
                return <li key={index}>{item.text}</li>;
              }
            } else if (
              helpChoice === "Pairing mode" &&
              item.text?.[sensorType]
            ) {
              return <li key={index}>{item.text?.[sensorType]}</li>;
            } else {
              return <li key={index}>{item.text}</li>;
            }
          }
          if (
            (helpChoice === "Battery placement" &&
              item?.image &&
              sensorType?.toLowerCase().includes(item?.image?.name)) ||
            (helpChoice === "Factory reset the sensor" &&
              item?.image &&
              sensorType?.toLowerCase().includes(item?.image?.name)) ||
            (helpChoice === "None of the other steps worked" &&
              item?.image &&
              sensorType?.toLowerCase().includes(item?.image?.name)) ||
            item?.image?.name === "hub"
          ) {
            return (
              <div style={{ marginBottom: "16px" }}>
                <img
                  key={index}
                  src={item?.image?.image}
                  alt={item?.image?.alt}
                  style={{
                    maxHeight: `${item?.image?.height}px`,
                    display: "flex",
                    alignItems: "center",
                    alignContent: "center",
                    justifyContent: "center",
                  }}
                />
              </div>
            );
          }
          if (item.note) {
            return <InstallNote note={item.note} key={index} />;
          }
          if (item.description) {
            return (
              <InstallDescription description={item.description} key={index} />
            );
          }
          return null;
        })}
      </ol>
    </div>
  );
};

export default TroubleshootingDesktopBody;
